import { action, observable, computed } from 'mobx';
import { setter } from 'mobx-decorators';
import agent from '../../services/web/agent';

class ServiceProvidersStore {

    @setter @observable serviceProviders = [];

    @action getAllServiceProviders() {

        return agent.ServiceProviders.getServiceProviders()
            .then(action(providers => {
                    
                this.serviceProviders = providers;
            }));
    }

    @action resetServiceProviders() {

        this.serviceProviders = [];
    }
}

export default new ServiceProvidersStore();


// WEBPACK FOOTER //
// ./src/stores/serviceProviders/index.js